module.exports = __webpack_public_path__ + "img/HEADER_CARRINHO_DETALHADO.b3f8ca21.png";